import { FC, useRef } from 'react';
import styles from './FileUpload.module.scss';

export interface FileUploadProps {
  onFileSelectSuccess: (...args: any[]) => void;
}

const FileUpload: FC<FileUploadProps> = ({ onFileSelectSuccess }) => {
  const fileInput = useRef<HTMLInputElement>(null);

  const handleFileInput = (e: any) => {
    onFileSelectSuccess(e.target.files[0]);
  };

  return (
    <div className={styles.fileUpload}>
      <input className={styles.fileUpload__input} id='file' name='file' type='file' onChange={handleFileInput} />
      <div className={styles.fileUpload__mask}></div>
    </div>
  );
};

export default FileUpload;
